/**
 * Map API payloads to card shape for /points listings.
 */
import { getPointCardImageUrl } from './pointImageUtils';

export { POINT_IMAGE_PLACEHOLDER } from './pointImageUtils';
export { getPointCardImageUrl, onPointImageError } from './pointImageUtils';

/**
 * Map API hotel payload to point shape for cards.
 */
export const mapHotelToPoint = (hotel) => ({
  id: hotel.id,
  slug: hotel.slug,
  title: hotel.name || hotel.title || 'Untitled Place',
  locationText: hotel.city || hotel.location || hotel.address || 'Pakistan',
  rating: hotel.average_rating ?? hotel.rating ?? 4.5,
  reviewsCount:
    hotel.total_reviews ?? hotel.review_count ?? hotel.reviewsCount ?? 0,
  infoText:
    hotel.short_description ||
    (hotel.description && hotel.description.slice(0, 50)) ||
    hotel.best_months ||
    '',
  imageUrl: getPointCardImageUrl(hotel),
  isRecommended: Boolean(hotel.is_featured || hotel.is_recommended),
  isFree: Boolean(hotel.is_free),
  categoryTag: hotel.point_category?.name || hotel.category_name || null,
  seasonTag: null,
});

/**
 * Map Points API payload to same card shape as mapHotelToPoint.
 */
export const mapPointToPlace = (point) => ({
  id: point.id,
  slug: point.slug,
  title: point.name || point.title || 'Untitled Place',
  locationText: point.city || point.area || point.address || 'Pakistan',
  rating: point.average_rating ?? point.rating ?? 4.5,
  reviewsCount:
    point.total_reviews ?? point.review_count ?? point.reviewsCount ?? 0,
  infoText:
    point.short_description ||
    (point.best_visit_months
      ? `${point.best_visit_months} · ${point.point_category?.name || ''}`.trim()
      : '') ||
    (point.description && point.description.slice(0, 50)) ||
    '',
  imageUrl: getPointCardImageUrl(point),
  isRecommended: Boolean(point.is_featured || point.is_recommended),
  isFree: Boolean(point.is_free),
  categoryTag: point.point_category?.name || point.category_name || null,
  seasonTag: point.best_visit_months || null,
});

/** Point categories come from API (hotelService.getPointCategories). */
export const CATEGORIES = [];
export const CATEGORY_META = {};

export const WHY_EXPLORE_POINTS = [
  'Verified Information',
  'Real Visitor Reviews',
  'Detailed Facilities',
  'Easy Directions',
];
